import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAgitatorHelical = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 80,
	height: 130,
	viewBox: "0 0 80.0 130.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 40.0 0.0 L 40.0 120.0 M 0.0 70.0 L 80.0 90.0 L 0.0 110.0 L 80.0 130.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgAgitatorHelical;
